import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';

interface IFormInputs {
    email: string;
}

const ForgotPassword: React.FC = () => {
    const { resetPassword } = useAuth();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<IFormInputs>();

    const onSubmit: SubmitHandler<IFormInputs> = async ({ email }) => {
        try {
            await resetPassword(email);
            toast.success('Ссылка для сброса пароля отправлена!');
            navigate('/signin');
        } catch (error: any) {
            toast.error(error.message || 'Ошибка сброса пароля');
        }
    };

    return (
        <Box sx={{ maxWidth: 400, mx: 'auto', mt: 5 }}>
            <Typography variant="h5" textAlign="center">Сброс пароля</Typography>
            <Typography variant="body2" textAlign="center" sx={{ mb: 3 }}>
                Введите email, и мы отправим вам ссылку для восстановления пароля.
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    {...register('email', {
                        required: 'Введите email',
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: 'Некорректный формат email',
                        },
                    })}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                />

                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={isSubmitting}
                    sx={{ mt: 2 }}
                >
                    {isSubmitting ? 'Отправка...' : 'Отправить'}
                </Button>
            </form>

            <Box textAlign="center" mt={2}>
                <Link to="/signin">Вернуться ко входу</Link>
            </Box>
        </Box>
    );
};

export default ForgotPassword;
